var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPerson(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12.9869 10.998c.3991.3986.6113.9471.5844 1.5105l-.0713 1.4915.1063 2.7568c.0048.1257-.0022.2517-.0211.3761l-1.2995 8.5916c-.0913.6046.3175 1.1698.9127 1.2625.5956.0928 1.1524-.3216 1.2439-.9264l1.1916-7.8778c.0274-.181.1829-.3148.366-.3148.183 0 .3386.1339.366.3148l1.1916 7.8778c.0914.6046.6485 1.0192 1.2439.9264.5953-.0928 1.0042-.6579.9126-1.2625l-1.2995-8.5915c-.0188-.1245-.0258-.2505-.021-.3763l.1065-2.7567-.0712-1.4919c-.0269-.5634.1853-1.1119.5843-1.5105l4.7761-4.77034c.278-.2776.2813-.73137.0082-1.01328-.2735-.28221-.7205-.28558-.9983-.00829l-3.997 3.9922c-.7435.74257-1.7513 1.15971-2.8021 1.15971-1.0509.0001-2.0588-.41705-2.8024-1.1597l-3.99647-3.99166c-.27802-.2776-.72503-.27408-.99838.00798-.27348.28206-.26985.73569.00817 1.01328z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.9852 6.98526c0 1.09648-.8889 1.98525-1.9852 1.98525-1.0965 0-1.9854-.88877-1.9854-1.98525 0-1.09649.8889-1.98526 1.9854-1.98526 1.0963 0 1.9852.88877 1.9852 1.98526",
    opacity: 0.6
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/Person.ff3b81864b4f0d874e544a44a784959e.svg";
export { ForwardRef as ReactComponent };